import axios from './axios';
import api from './api.mappings';
export class DingTalkApi {
    sign(params) {
        return axios.get(api.dingTalk.sign, {
            params
        });
    }
    login(params) {
        return axios.get(api.dingTalk.login, {
            params
        });
    }
}
